import { render, staticRenderFns } from "./DetailedCalculateResult.vue?vue&type=template&id=6f2081c8&"
import script from "./DetailedCalculateResult.vue?vue&type=script&lang=js&"
export * from "./DetailedCalculateResult.vue?vue&type=script&lang=js&"
import style0 from "./DetailedCalculateResult.vue?vue&type=style&index=0&id=6f2081c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports